import React from "react";

import {
    Checkbox,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    Input,
    useFormContext,
} from "@formant/ui-kit";

export const UnstructuredParameters: React.FC = () => {
    const { control, watch } = useFormContext();
    const parameterEnabled = watch("parameterEnabled");

    return (
        <div className="space-y-4">
            <FormField
                control={control}
                name="parameterEnabled"
                render={({ field }) => (
                    <FormItem className="flex flex-row items-center space-x-2">
                        <FormControl>
                            <Checkbox
                                checked={field.value}
                                onCheckedChange={field.onChange}
                            />
                        </FormControl>
                        <FormLabel>Enable Parameters</FormLabel>
                    </FormItem>
                )}
            />

            {parameterEnabled && (
                <>
                    <FormField
                        control={control}
                        name="allowParameterOverride"
                        render={({ field }) => (
                            <FormItem className="flex flex-row items-center space-x-2">
                                <FormControl>
                                    <Checkbox
                                        checked={field.value}
                                        onCheckedChange={field.onChange}
                                    />
                                </FormControl>
                                <FormLabel>Allow Parameter Override</FormLabel>
                            </FormItem>
                        )}
                    />

                    <FormField
                        control={control}
                        name="parameterValue"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Parameter Value</FormLabel>
                                <FormControl>
                                    <Input
                                        {...field}
                                        placeholder="Enter parameter value"
                                    />
                                </FormControl>
                            </FormItem>
                        )}
                    />
                </>
            )}
        </div>
    );
};
